import React from 'react';
import { 
    Edit2, Trash2, CheckCircle, Home, XCircle, 
    RefreshCcw, MapPin, Key, Bed, Tent, 
    Hotel, Building, Building2, Warehouse, Palmtree, 
    HelpCircle, Mountain, TreePine, Castle, Gem, 
    Camera, Library, PartyPopper, Snowflake, Tractor, 
    Sprout, Palette, 
    Dumbbell,
    Film,
    Clapperboard
} from 'lucide-react';
import type { MantenedorRecord } from '../types';

const AVAILABLE_ICONS: Record<string, React.ComponentType<any>> = {
    Home,
    Building,
    Building2,
    Hotel,
    Warehouse,
    Tent,
    Palmtree,
    Mountain,
    TreePine,
    Castle,
    Gem,
    Camera,
    Library,
    PartyPopper,
    Snowflake,
    Tractor,
    Sprout,
    Palette,
    Bed,
    Key,
    MapPin,
    Dumbbell,
    Clapperboard,
    Film
};

interface TableProps {
    records: MantenedorRecord[];
    onEdit: (record: MantenedorRecord) => void;
    onToggleStatus: (record: MantenedorRecord) => void;
    showIconColumn?: boolean;
    showDescriptionColumn?: boolean;
}

export const MantenedoresTable: React.FC<TableProps> = ({
    records, onEdit, onToggleStatus, showIconColumn,
}) => {

    /* let totalColumns = 5; 
    if (showIconColumn) totalColumns++;
    if (showDescriptionColumn) totalColumns++; */

    return (
        <div className="flex-1 w-full overflow-auto hide-scrollbar bg-white">
            <table className="w-full min-w-[700px] border-collapse">
                <thead className="sticky top-0 z-10 bg-gray-50 border-b border-gray-200">
                    <tr>
                        <th className="px-4 sm:px-7 py-3 text-left text-[10px] font-bold tracking-[0.8px] text-gray-500 uppercase">ID</th>
                        <th className="px-4 py-3 text-left text-[10px] font-bold tracking-[0.8px] text-gray-500 uppercase">Código</th>
                        {/* {showIconColumn && (
                            <th className="px-4 py-3 text-left text-[10px] font-bold tracking-[0.8px] text-gray-500 uppercase">Ícono</th>
                        )} */}
                        <th className="px-4 py-3 text-left text-[10px] font-bold tracking-[0.8px] text-gray-500 uppercase">Ícono</th>
                        <th className="px-4 py-3 text-left text-[10px] font-bold tracking-[0.8px] text-gray-500 uppercase">Nombre</th>
                        {/* {showDescriptionColumn && (
                            <th className="px-4 py-3 text-left text-[10px] font-bold tracking-[0.8px] text-gray-500 uppercase">Descripción</th>
                        )} */}
                        <th className="px-4 py-3 text-left text-[10px] font-bold tracking-[0.8px] text-gray-500 uppercase">Descripción</th>
                        <th className="px-4 py-3 text-left text-[10px] font-bold tracking-[0.8px] text-gray-500 uppercase">Estado</th>
                        <th className="px-4 sm:px-7 py-3 text-right text-[10px] font-bold tracking-[0.8px] text-gray-500 uppercase">Acciones</th>
                    </tr>
                </thead>
                <tbody>
                    {records.length === 0 ? (
                        <tr>
                            <td colSpan={7} className="px-4 py-12 text-center text-sm text-gray-500">
                                No se encontraron registros.
                            </td>
                        </tr>
                    ) : (
                        records.map((record) => {
                            const IconComponent = record.icon ? AVAILABLE_ICONS[record.icon] : null;

                            const isActive = record.status === 1;

                            return (
                                <tr key={record.id} className="transition-colors hover:bg-gray-50 border-b border-gray-100 last:border-0">
                                    <td className="px-4 sm:px-7 py-3.5 text-[13px] align-middle">
                                        <span className="font-mono text-gray-500">#{record.id}</span>
                                    </td>
                                    <td className="px-4 py-3.5 align-middle">
                                        <span className="px-2 py-1 text-[11px] font-mono font-semibold text-gray-700 bg-gray-100 border border-gray-200 rounded">
                                            {record.code}
                                        </span>
                                    </td>

                                    {/* COLUMNA DE ÍCONO */}
                                    {showIconColumn && (
                                        <td className="px-4 py-3.5 align-middle">
                                            {record.icon ? (
                                                <div className="flex items-center gap-2.5">
                                                    {IconComponent ? (
                                                        <div className="flex items-center justify-center w-8 h-8 bg-[#4f6df5]/10 text-[#4f6df5] rounded-md shadow-sm">
                                                            <IconComponent size={16} strokeWidth={2.5} />
                                                        </div>
                                                    ) : (record.icon.startsWith('http') || record.icon.startsWith('/') || record.icon.includes('.')) ? (
                                                        <div className="flex items-center justify-center w-8 h-8 overflow-hidden bg-gray-50 border border-gray-200 rounded-md shadow-sm relative">
                                                            <div className="absolute inset-0 flex items-center justify-center text-gray-400 bg-gray-100">
                                                                <HelpCircle size={16} strokeWidth={2} />
                                                            </div>
                                                            <img
                                                                src={record.icon}
                                                                alt={record.name}
                                                                className="relative z-10 object-contain w-5 h-5 opacity-70"
                                                                onError={(e) => {
                                                                    (e.target as HTMLImageElement).style.display = 'none';
                                                                }}
                                                            />
                                                        </div>
                                                    ) : (
                                                        <div className="flex items-center justify-center w-8 h-8 bg-gray-100 text-gray-400 border border-gray-200 rounded-md shadow-sm" title={`Ícono desconocido: "${record.icon}"`}>
                                                            <HelpCircle size={16} strokeWidth={2} />
                                                        </div>
                                                    )}
                                                </div>
                                            ) : (
                                                <span className="text-[12px] italic text-gray-400">Sin ícono</span>
                                            )}
                                        </td>
                                    )}

                                    <td className="px-4 py-3.5 align-middle">
                                        <span className="text-[13px] font-semibold text-gray-900">{record.name}</span>
                                    </td>

                                    <td className="px-4 py-3.5 align-middle max-w-[300px]">
                                        <span className="text-[13px] text-gray-600 block whitespace-normal break-words leading-relaxed">
                                            {record.description}
                                        </span>
                                    </td>

                                    {/* COLUMNA DE ESTADO */}
                                    <td className="px-4 py-3.5 align-middle">
                                        <span className={`inline-flex items-center gap-1 px-2 py-0.5 text-[10px] font-bold tracking-wide uppercase rounded-full whitespace-nowrap border 
                                            ${isActive
                                                ? 'bg-emerald-50 text-emerald-700 border-emerald-100'
                                                : 'bg-red-50 text-red-700 border-red-100'
                                            }`}>
                                            {isActive ? <CheckCircle size={10} /> : <XCircle size={10} />}
                                            {isActive ? 'Activo' : 'Inactivo'}
                                        </span>
                                    </td>

                                    {/* ACCIONES */}
                                    <td className="px-4 sm:px-7 py-3.5 align-middle text-right">
                                        <div className="flex items-center justify-end gap-2">
                                            <button
                                                onClick={() => onEdit(record)}
                                                className="p-1.5 text-gray-400 transition-colors rounded hover:bg-gray-100 hover:text-[#4f6df5]"
                                                title="Editar"
                                            >
                                                <Edit2 size={16} />
                                            </button>

                                            <button
                                                onClick={() => onToggleStatus(record)}
                                                className={`p-1.5 transition-colors rounded ${isActive
                                                    ? 'text-gray-400 hover:bg-red-50 hover:text-red-600'
                                                    : 'text-gray-400 hover:bg-emerald-50 hover:text-emerald-600'
                                                }`}
                                                title={isActive ? 'Desactivar' : 'Activar'}
                                            >
                                                {isActive ? <Trash2 size={16} /> : <RefreshCcw size={16} />}
                                            </button>
                                        </div>
                                    </td>
                                </tr>
                            );
                        })
                    )}
                </tbody>
            </table>
        </div>
    );
};